module.exports = __webpack_public_path__ + "img/img_product_FGF_1.105bb57f.jpg";